<template>
  <q-layout view="hHh Lpr lFf"> <!-- Be sure to play with the Layout demo on docs -->
    <!-- (Optional) The Header -->
    <q-layout-header id="main-header" class="no-shadow">
      <q-toolbar color="white" text-color="#727272">
        <div id="main-header-left">
          <div id="menu-icon-holder" @click="toggleNavDrawer()">
            <span id="menu-icon"></span>
          </div>
          <div class="logo text-center"><span>cascades</span></div>
        </div>
        <q-toolbar-title class="text-center">          
          <q-icon name="fa fa-user" />
          {{this.$route.name}}
        </q-toolbar-title>

        <div id="quick-search" class="hidden">
          <!-- <q-search hide-underline clearable placeholder="Quick Search" /> -->
        </div>

        <notification-center ref="notificationCenter" />
        <!--@click.stop="logoutUser()" -->
        <!-- User Icon -->
        <div class="label green round action" v-ripple.mat >
          <span>{{userInitials}}</span>
          <q-popover>
            <q-list>
            <q-item link v-close-overlay @click.native="selectUser(user)">
              <q-item-side icon="person" text-color="secondary" />
              <q-item-main>
                  <q-item-tile label> View Profile</q-item-tile>
              </q-item-main>
            </q-item>
            <q-item link v-close-overlay @click.native="logoutUser()">
                <q-item-side icon="power_settings_new" text-color="secondary" />
                <q-item-main>
                    <q-item-tile label> Logout</q-item-tile>
                </q-item-main>
            </q-item>
            </q-list>
          </q-popover>
        </div>
      </q-toolbar>
    </q-layout-header>

    <!-- (Optional) A Drawer; you can add one more with side="right" or change this one's side -->
    <q-layout-drawer id="left-menu" side="left" :value="navDrawer">
      <!-- Menu here -->
      <ul>
        <li
          v-for="(item, i) in navigationItems"
          :key="i"
          :class="{'no-expand':item.expand === false, 'red-circle': (item.title == 'Orders' && orderNotification)}"
          v-if="permission(item.$p, null, item)"
        >
          <router-link :to="item.route" v-if="item.route">
            <q-icon v-if="item.icon" :name="item.icon" />
            <span v-text="item.title"></span>
          </router-link>
          <a href="#" @click.prevent=";" v-if="!item.route">
            <q-icon v-if="item.icon" :name="item.icon" />
            <span v-text="item.title"></span>
          </a>
          <ul v-if="item.children && item.children.length">
            <li v-for="(child, c) in item.children" :key="c" v-if="permission(child.$p, true)">
              <router-link :to="child.route" v-if="child.route">
                <q-icon v-if="child.icon" :name="child.icon" />
                <span v-text="child.title"></span>
              </router-link>
              <a href="#" @click.prevent=";" v-if="!child.route && child.modal" @click="openModal(child.modal)">
                <q-icon v-if="child.icon" :name="child.icon" />
                <span v-text="child.title"></span>
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </q-layout-drawer>
    <q-page-container>
      <router-view />
    </q-page-container>
    <certificates-modal v-if="certificatesModal" />
    <student-completion v-if="studentCompletionModal" />
    <recruiter-referral v-if="recruiterReferralModal" />
    <accounting-report v-if="accountingReportModal" />
    <affiliate-schedule v-if="affiliateScheduleModal" />
    <unscheduled-classes-report v-if="unscheduledClassesModal" />
    <address-validation-report v-if="addressValidationModal" />

    <!-- Global Modals -->  
    <payment-modal v-if="processPaymentModalOpen" />
    <order-details-modal v-if="detailsModalOpenState" />
    <user-details-modal v-if="userDetailsOpen" />
    <user-wizard-modal v-if="userWizardOpen" />    
    <class-details-modal v-if="classesModalState" />  
    <schedule-upload-modal v-if="scheduleUploadOpen" /> 
    <job-modal v-if="jobModalOpen" />

  </q-layout>
</template>

<script>
import {QSpinnerPuff} from 'quasar'
import { mapActions, mapState, mapMutations } from 'vuex'
import NotificationCenter from '../components/Shared/NotificationCenter'
import StudentCompletion from '../components/Reports/StudentCompletion'
import RecruiterReferral from '../components/Reports/RecruiterReferral'
import AccountingReport from '../components/Reports/AccountingReport'
import AffiliateSchedule from '../components/Reports/AffiliateSchedule'
import UnscheduledClassesReport from '../components/Reports/UnscheduledClassesReport'
import AddressValidationReport from '../components/Reports/AddressValidationReport'
import CertificatesModal from '../components/Reports/certificatesModal'
// Global Modals
import paymentModal from '../components/Orders/processPaymentModal'
import orderDetailsModal from '../components/Orders/orderDetailsModal'
import UserDetailsModal from '../components/User/UserDetailsModal'
import UserWizardModal from '../components/User/UserWizardModal'
import ClassDetailsModal from '../components/Class/ClassDetailsModal'
import ScheduleUploadModal from '../components/Class/ScheduleUpload'
import JobModal from '../components/Jobs/JobModal'

const KENNY_HUANG_USER_IDS = [702, 705, 1915, 2270]

export default {
  components: {
    NotificationCenter,
    CertificatesModal,
    StudentCompletion,
    RecruiterReferral,
    AccountingReport,
    UnscheduledClassesReport,
    AddressValidationReport,
    AffiliateSchedule,
    paymentModal,
    orderDetailsModal,
    UserDetailsModal,
    UserWizardModal,
    ClassDetailsModal,
    ScheduleUploadModal,
    JobModal,
  },
  async created () {
    this.$store.dispatch('loadPermissions')
    this.$q.loading.show({
      delay: 100,
      message: 'Loading..',
      spinner: QSpinnerPuff,
      customClass: 'main'
    })
  },
  async mounted(){
    let vm = this
    // Set the current user in store
    await vm.setCurrentUser()
      .then(()=>{
        vm.$q.loading.hide()
        if(vm.currentUser().PROMPT_CHANGE_PASSWORD){
          vm.$q.dialog({
            title: 'Change Default Password',
            message: 'For your security, please change your password now.',
            ok: 'Change Now',
            cancel: "I'll wait",
            preventClose: true
          })
          .then(()=>{
            vm.$store.dispatch('users/select',{ vm, selectedUser: vm.currentUser()})
            vm.updateSelectedTab('security')
          })
          .catch(()=>{})
        }
      })

    // Whether to show the address verification chips and approval warning
    vm.$store.dispatch('settings/fetch')

    vm.fetchOrderNotifications()
    .then(res =>
      vm.orderNotification = res.notify
    )

  },
  data () {
    return {
      module: this.$route.meta.module,
      orderNotification: false,
    }
  },
  computed: {
    ...mapState({
      navDrawer: state => state.shared.navDrawer,
      navigationItems: state => state.shared.navigationItems,
      certificatesModal: s=> s.shared.certificatesModal,
      studentCompletionModal: s => s.shared.studentCompletionModal,
      recruiterReferralModal:  s => s.shared.recruiterReferralModal,
      accountingReportModal: s => s.shared.accountingReportModal,
      affiliateScheduleModal: s => s.shared.affiliateScheduleModal,
      unscheduledClassesModal: s => s.shared.unscheduledClassesModal,
      addressValidationModal: s => s.shared.addressValidationModal,
      detailsModalOpenState: s => s.orders.detailsModalOpenState,
      processPaymentModalOpen: s => s.orders.processPaymentModalOpen,
      userDetailsOpen: state => state.users.userModal.open,
      userWizardOpen: state => state.users.userWizardModal.open,
      classesModalState: s => s.classes.classesModalState,
      scheduleUploadOpen: s=> s.classes.scheduleUploadOpen,
      jobModalOpen: s => s.jobs.jobModalOpen
    }),
    ...mapState('auth',{
      'user' : s => s.user
    }),
    userInitials(){
      const vm = this
      return vm.user ? `${vm.user.USER_FIRST_NAME[0].toUpperCase()}${vm.user.USER_LAST_NAME[0].toUpperCase()}` : '?'
    }
  },
  methods: {
    ...mapActions('auth', [
      'logoutUser',
      'viewUserProfile',
      'setCurrentUser'
    ]),
    ...mapActions('users',[
      'select'
    ]),
    ...mapActions('notifications',[
      'fetchOrderNotifications'
    ]),
    ...mapMutations([
      'toggleNavDrawer',
      'openDetails',
      'toggleQuickSearch',
      'openModal'
    ]),
    ...mapMutations('users', [
      'updateSelectedTab'
    ]),
    selectUser(selectedUser){
      let vm = this
      vm.$q.loading.show({
        message: 'Loading User'
      })
      vm.select(selectedUser)
        .then(() => {
          vm.$q.loading.hide()
        })
    },
    permission(permission, defaultReturnValue, item){
      // TODO remove this when adding support for all affiliates
      if (item && item.module === "jobs" && this.$p(['AFFILIATE'])) {
        return KENNY_HUANG_USER_IDS.includes(this.user.USER_ID)
      }

      if(permission && Array.isArray(permission) && permission[0].length > 0){
        let searchType = (permission.length > 1) ? permission[1] : null 
        return searchType ? this.$p(permission[0], searchType) : this.$p(permission[0])
      }
      else{
        return defaultReturnValue ? defaultReturnValue : false
      }
    },
  }
}
</script>

<style lang="stylus">
@import '~variables'
.logo{
  font-size 18px
  padding-top 3px
}

/*
 * Main Header
 */

header-height = 60px

#main-header
  border-bottom 1px solid border-color;
  #main-header-left
    width left-bar-width
    height header-height
    padding 16px 20px 0 13px
    float left
    box-shadow: 0px 0 42px rgba(0,0,0,0.2)
    @media (max-width: $breakpoint-sm)
      width auto
      box-shadow none
      .logo 
        display none
  .q-toolbar
    padding 0 30px 0 0
    .q-toolbar-title
      font-weight 100
      font-size 20px
      color $secondary
      i
        color $primary
        font-size:25px
.q-toolbar
  min-height header-height

/*
 * Left Menu
 */
#left-menu
  border-right 1px solid border-color
  overflow visible
  @media (max-width: $breakpoint-sm)
    overflow auto
  > ul
    margin-top 20px
    list-style none
    padding 0
    > li
      display block
      position relative
      &:hover > a span
        padding-left 4px 
      &:hover       
        &.no-expand > a,
        > a:not(.router-link-active)
          i
            color $primary
          &+ ul
            position absolute
            left 100%
            top -50px
            width 300px
            background #454545
            max-height 1000px 
            padding 10px 0
            border-radius 0 12px 12px 0
            @media (max-width: $breakpoint-sm)
              position static
              background #f5f5f5
              width 100%
              padding-left 60px
              a
                color text-color !important
                &:hover
                  background-color transparent !important
            li
              padding: 0
              a
                padding 15px 20px
                color #fff
                display block
                transition(all 0.2s ease-in-out)
                &:hover 
                  background-color #565656
      > ul
        max-height 0 
        overflow hidden
      &:not(.no-expand)
        > a
          &.router-link-active + ul     
              display block
              max-height 1000px
              border-top 1px solid #eaeaea
              padding-left 0
      > a
        text-decoration none
        font-size 18px
        font-weight 400
        display block
        padding 15px 50px
        color text-color
        position relative
        span
          transition(all 0.2s ease-in-out)         
        &.router-link-active
          color $primary
          padding-left:46px
          background #e6ebf9
          // Left Active Border
          border-left 4px solid $primary
          &:before
            content ""
            width 14px
            height 100%
            position absolute
            left -14px
            top 0
            box-shadow: 0px 0 40px $primary
        i
          font-size 23px
          vertical-align middle
          display inline-block
          margin-right 5px
          width 30px        
        &.router-link-exact-active
          position relative
          &:after
            content ""
            width 10px
            height 10px
            position absolute
            right 20px
            top 22px
            border-radius 20px
            box-shadow: 0px 0 40px $primary
            background $primary
      ul
        background #f5f5f5
        li
          padding 0 0 0 0
          list-style none
          a
            font-weight 400
            font-size 17px
            text-decoration none
            color #636363
            display block
            padding 20px 0
            padding-left 75px
            &.router-link-exact-active
              color $primary
              background #e6ebf9
              position relative
              &:after
                content ""
                width 10px
                height 10px
                position absolute
                right 20px
                top 28px
                border-radius 20px
                box-shadow: 0px 0 40px $primary
                background $primary
              i 
                color $primary
            i 
              display inline-block
              margin-right 5px
              width 26px
              font-size 24px
              color #969696

/*
 * Menu Bar
 */
menu-bar-height = 2px
menu-bar-color = #adadad
menu-bar-width = 15px
#menu-icon
  content ""
  height menu-bar-height
  background menu-bar-color
  width menu-bar-width
  position relative
  vertical-align baseline
  display inline-block
  transition(all 0.2s ease-in-out)
  &:before
    content ""
    display inline-block
    height menu-bar-height
    position absolute
    background menu-bar-color
    top -5px
    left 0
    width:menu-bar-width + 5px
    transition(all 0.2s ease-in-out)
  &:after
    content ""
    display inline-block
    height menu-bar-height
    position absolute
    background menu-bar-color
    top 5px
    left 0
    width menu-bar-width + 3px
    transition(all 0.2s ease-in-out)

#menu-icon-holder
  position:relative;
  height 30px
  width 30px
  cursor pointer
  text-align center
  float left
  &:hover
    #menu-icon{
      background darken(menu-bar-color,20%)
      &:before,
      &:after{
        background darken(menu-bar-color,20%)
      }
    }

#quick-search,
#notifications
  .q-icon
    font-size:25px
    color #a2a2a2
.q-loading.main
  background rgba(148, 148, 148, 0.9);
  > div 
    text-shadow none
.red-circle
  position relative
  &:after
    content ""
    width 10px
    height 10px
    position absolute
    right 20px
    top 22px
    border-radius 20px
    box-shadow: 0px 0 40px $primary
    background $negative
</style>
